/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Task } from './Task.js';
import {
    TaskFromJSON,
    TaskFromJSONTyped,
    TaskToJSON,
} from './Task.js';

/**
 * 
 * @export
 * @interface SingleTaskResponse
 */
export interface SingleTaskResponse {
    /**
     * 
     * @type {Task}
     * @memberof SingleTaskResponse
     */
    data?: Task;
    /**
     * 
     * @type {number}
     * @memberof SingleTaskResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleTaskResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleTaskResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof SingleTaskResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the SingleTaskResponse interface.
 */
export function instanceOfSingleTaskResponse(value: object): boolean {
    return true;
}

export function SingleTaskResponseFromJSON(json: any): SingleTaskResponse {
    return SingleTaskResponseFromJSONTyped(json, false);
}

export function SingleTaskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleTaskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : TaskFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function SingleTaskResponseToJSON(value?: SingleTaskResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': TaskToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

